import * as THREE from "three";
import { Canvas, extend, useFrame, useThree } from "@react-three/fiber";
import { shaderMaterial, Edges, RenderTexture, OrthographicCamera, RoundedBox, Instances, Instance, PerspectiveCamera, Float, Box, useTexture } from "@react-three/drei";
import { useRef, useMemo } from "react";
import yeastVertexShader from '../../../shaders/yeast/vertex.glsl'
import yeastFragmentShader from '../../../shaders/yeast/fragment.glsl'
import { RoundedBoxGeometry } from "three/examples/jsm/Addons.js";

export default function LevuresPlane(props) {
    const materialRef = useRef();

    const { camera, viewport } = useThree()
    const { width, height } = viewport


    const textures = [
        useTexture(import.meta.env.BASE_URL + 'static/levure-texture.webp')
    ]

    const YeastShaderMaterial = shaderMaterial(
        {
            color: new THREE.Color('white'),
            scale: new THREE.Vector2(1, 1),
            imageBounds: new THREE.Vector2(1, 1),
            resolution: 512,
            zoom: 1,
            radius: 0,
            grayscale: 0,
            opacity: 1,
            map: textures[0],
            uTime: { value: 0 },
            uOffset: { value: 0 }
        },
        yeastVertexShader,
        yeastFragmentShader,
    )

    extend({ YeastShaderMaterial })

    function isOverlapping(newPos, newSize, levures) {
        for (let i = 0; i < levures.length; i += 3) {
            const dx = levures[i] - newPos[0];
            const dy = levures[i + 1] - newPos[1];
            const distance = Math.sqrt(dx * dx + dy * dy);
            const minDist = (levures[i + 2] + newSize) * 0.43; // Réduction de la marge pour permettre un léger chevauchement
            if (distance < minDist) return true;
        }
        return false;
    }

    const levuresArray = useMemo(() => {
        const levures = [];
        let attempts = 0;
        while (levures.length / 3 < 100 && attempts < 3000) {
            let newPos = [(Math.random() - 0.5) * 14, (Math.random() - 0.5) * 6];
            let newSize = 0.2 + Math.random() * 0.5;
            if (!isOverlapping(newPos, newSize, levures)) {
                levures.push(...newPos, newSize);
            }
            attempts++;
        }
        // console.log("Levures générées:", levures); // Debugging output
        return new Float32Array(levures);
    }, []);

    useFrame(({ clock }) => {
        if (materialRef.current) {
            materialRef.current.uTime = clock.elapsedTime;
        }
    });

    return (<>
    
        <mesh {...props}>
            <planeGeometry args={[width / 2 * .85, 2.5]} />

            <meshBasicMaterial transparent toneMapped={false} blending={THREE.MultiplyBlending}>
                <RenderTexture attach={'map'} anisotropy={16}>
                    <OrthographicCamera makeDefault manual zoom={100} position={[0, 0, 5]} />
                    <color args={["white"]} attach="background" />
                    <ambientLight intensity={0.5} />
                    <Instances>
                        <planeGeometry attach={'geometry'} />
                        <yeastShaderMaterial ref={materialRef} key={YeastShaderMaterial.key} transparent opacity={1} depthTest={0} depthWrite={false} zoom={1} uTime={0} uOffset={0} />
                        {Array.from({ length: levuresArray.length / 6 }).map((_, index) => (
                            <Float key={index} speed={80} rotationIntensity={0.03} floatIntensity={0.02}>
                                <Instance
                                    scale={[levuresArray[index * 3 + 2], levuresArray[index * 3 + 2] * 1 - (Math.random()*.2), 0.1 + Math.random() * 0.2]}
                                    position={[levuresArray[index * 3], levuresArray[index * 3 + 1], (Math.random() - 0.5) * 2]}
                                    rotation={[Math.PI * Math.random() * 0.25, 0, Math.PI * (Math.random() * 0.1)]}
                                />
                            </Float>
                        ))}
                    </Instances>
                </RenderTexture>
            </meshBasicMaterial>
            {/* <Edges
                lineWidth={1}
                threshold={0.5}
                color="black"
                scale={1}
                opacity={.4}
                depthTest={true}
                depthWrite={false}
                renderOrder={1000}
                polygonOffset={false}
                polygonOffsetFactor={10}
            /> */}
        </mesh>
    </>);
}
